import type { Theme } from '@mui/material';

export const styles = {
  cancelButton: (theme: Theme) => ({
    background: theme.palette.primary.light,
    color: theme.palette.primary.main,
  }),
};
